export const PRODUCT_MATCH_CRITERIA = {
  PRODUCT_GEOMETRY: 'PRODUCT_GEOMETRY',
  PRODUCT_SKU_FUZZY: 'PRODUCT_SKU_FUZZY',
  PRODUCT_SKU_EXACT: 'PRODUCT_SKU_EXACT',
  PRODUCT_LINKED_IN_BAQ: 'PRODUCT_LINKED_IN_BAQ',
  PRODUCT_SKU_EQUIVALENT: 'PRODUCT_SKU_EQUIVALENT',
};

export const PRODUCT_MATCH_TYPE = {
  AMBIGUOUS: 'ambiguous',
  UNAMBIGUOUS: 'unambiguous',
};
